import { createAsyncThunk } from '@reduxjs/toolkit'
import { wikiAPI } from '../../utils/supabase'

// === CONTINUE READING THUNKS ===

export const recordPageView = createAsyncThunk(
  'wiki/recordPageView',
  async (pageId, { rejectWithValue }) => {
    const { data, error } = await wikiAPI.recordPageView(pageId)
    if (error) return rejectWithValue(error.message)
    return { pageId, last_viewed_at: data.last_viewed_at }
  }
)

export const saveScrollPosition = createAsyncThunk(
  'wiki/saveScrollPosition',
  async ({ pageId, scrollPosition }, { rejectWithValue }) => {
    const { data, error } = await wikiAPI.saveScrollPosition(pageId, scrollPosition)
    if (error) return rejectWithValue(error.message)
    return { pageId, scroll_position: data.scroll_position }
  }
)
